// extracted by css-extract-rspack-plugin
export default {"cls1":"memory_ladder-cls1_Q--","cls2":"memory_ladder-cls2_Q4_ memory_ladder-cls1_Q--"};